<template>
    <main dir="rtl" class="flex-1 pb-8 dashboard-report">
        <!-- Report Header (always visible) -->
        <div class="report-header">
            <div class="header-logos">
                <div class="left-logo">
                    <img :src="appLogo" alt="شعار التطبيق" class="app-logo" />
                </div>
                <div class="center-title">
                    <h1 class="pdf-title">تقرير الإحصائيات اليومية</h1>
                    <p class="pdf-subtitle">{{ startDate }} - {{ endDate }} | {{ selectedSessionName }}</p>
                    <p class="pdf-organization">{{ selectedOrganizationName }}</p>
                </div>
                <div class="right-logo">
                    <img v-if="selectedOrganization && (selectedOrganization.logoUrl || selectedOrganization.logoBase64)" 
                         :src="selectedOrganization.logoUrl || `data:image/jpeg;base64,${selectedOrganization.logoBase64}`" 
                         :alt="selectedOrganization.name"
                         class="organization-logo" />
                </div>
            </div>
            <hr class="header-divider" />
        </div>

        <!-- Cards -->
        <div class="mt-8">
            <div class="mx-auto px-4 sm:px-6 lg:px-8">
                <div class="mt-2 flex flex-wrap items-center gap-3">
                    <h2 class="text-lg font-medium text-gray-900">الاحصائيات اليومية</h2>
                    <select @change="changeSessionsId(masterSessionValue)" v-model="masterSessionValue"
                        class=" w-60 h-12 border border-gray-300 bg-white rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-lg">
                        <option disabled value="" selected>الرجاء اختيار الجلسة</option>
                        <option value="all">جميع الجلسات</option>
                        <option v-for="master in masterSessionsList" :key="master.id" :value="master.id">{{
                        master.sessionsName }}</option>
                    </select>

                    <select v-model="selectedOrganizationId" @change="getDashBordData()"
                        class="w-60 h-12 border border-gray-300 bg-white rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-lg">
                        <option value="">جميع الجهات</option>
                        <option v-for="org in organizations" :key="org.id" :value="org.id">
                            {{ org.name }}
                        </option>
                    </select>


                    <div dir="ltr" class="w-72">
                        <VueDatePicker v-model="date" :format="format" range @blur="onClickDate()"
                            :max-date="new Date()" class="w-full h-full text-lg"></VueDatePicker>
                    </div>
                    <button class="button" @click="getDashBordData()">بحث</button>
                    <!--
                    <button class="button-download" @click="downloadReportFromBe(1, false)"> تقرير الورد اليومي
                        (بدون الاسم)</button>
                    <button class="button-download" @click="downloadReportFromBe(1, true)"> تقرير الورد اليومي (مع
                        الاسم)</button>
                    <button class="button-download" @click="downloadReportFromBe(2, true)"> تقرير الحلقة</button>
                   <button class="button-download" @click="sessionsReport()"> جدول المواعيد</button> -->
                </div>

                <div class="mt-2 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 mt-8">
                    <div class="overflow-hidden shadow rounded-lg bg-hafadh-olive">
                        <div class="p-5">
                            <div class="flex items-center">
                                <div class="w-0 flex-1">
                                    <dl class="space-y-2">
                                        <dt class="text-sm font-medium text-white truncate">
                                            عدد الدارسين
                                        </dt>
                                        <dd>
                                            <div class="text-xl font-medium text-white">
                                                {{ this.totalStudent }}
                                            </div>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="overflow-hidden shadow rounded-lg bg-hafadh-gold">
                        <div class="p-5">
                            <div class="flex items-center">
                                <div class="w-0 flex-1">
                                    <dl class="space-y-2">
                                        <dt class="text-sm font-medium text-white truncate">
                                            عدد الختمات
                                        </dt>
                                        <dd>
                                            <div class="text-xl font-medium text-white">
                                                {{ this.totalOfEnd }}
                                            </div>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="overflow-hidden shadow rounded-lg bg-hafadh-olive">
                        <div class="p-5">
                            <div class="flex items-center">
                                <div class="w-0 flex-1">
                                    <dl class="space-y-2">
                                        <dt class="text-sm font-medium text-white truncate">
                                            عدد الاوجة المعروضة
                                        </dt>
                                        <dd>
                                            <div class="text-xl font-medium text-white">
                                                {{ this.totalPages }}
                                            </div>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="overflow-hidden shadow rounded-lg bg-hafadh-gold">
                        <div class="p-5">
                            <div class="flex items-center">
                                <div class="w-0 flex-1">
                                    <dl class="space-y-2">
                                        <dt class="text-sm font-medium text-white truncate">
                                            عدد أوجه الحفظ
                                        </dt>
                                        <dd>
                                            <div class="text-xl font-medium text-white">
                                                {{ this.totalPagesSaved }}
                                            </div>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="overflow-hidden shadow rounded-lg bg-hafadh-olive">
                        <div class="p-5">
                            <div class="flex items-center">
                                <div class="w-0 flex-1">
                                    <dl class="space-y-2">
                                        <dt class="text-sm font-medium text-white truncate">
                                            عدد أوجه المراجعة
                                        </dt>
                                        <dd>
                                            <div class="text-xl font-medium text-white">
                                                {{ this.totalPagesReviewed }}
                                            </div>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="overflow-hidden shadow rounded-lg bg-hafadh-gold">
                        <div class="p-5">
                            <div class="flex items-center">
                                <div class="w-0 flex-1">
                                    <dl class="space-y-2">
                                        <dt class="text-sm font-medium text-white truncate">
                                            عدد الاجزاء
                                        </dt>
                                        <dd>
                                            <div class="text-xl font-medium text-white">
                                                {{ this.numberOfParts }}
                                            </div>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="overflow-hidden shadow rounded-lg bg-hafadh-olive">
                        <div class="p-5">
                            <div class="flex items-center">
                                <div class="w-0 flex-1">
                                    <dl class="space-y-2">
                                        <dt class="text-sm font-medium text-white truncate">
                                            عدد الحسنات
                                        </dt>
                                        <dd>
                                            <div class="text-xl font-medium text-white">
                                                {{ this.numberOfHasnat }}
                                            </div>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="overflow-hidden shadow rounded-lg bg-hafadh-gold">
                        <div class="p-5">
                            <div class="flex items-center">
                                <div class="w-0 flex-1">
                                    <dl class="space-y-2">
                                        <dt class="text-sm font-medium text-white truncate">
                                            عدد الحروف
                                        </dt>
                                        <dd>
                                            <div class="text-xl font-medium text-white">
                                                {{ this.numberOfHroof }}
                                            </div>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="overflow-hidden shadow rounded-lg bg-hafadh-olive">
                        <div class="p-5">
                            <div class="flex items-center">
                                <div class="w-0 flex-1">
                                    <dl class="space-y-2">
                                        <dt class="text-sm font-medium text-white truncate">
                                            عدد الايات
                                        </dt>
                                        <dd>
                                            <div class="text-xl font-medium text-white">
                                                {{ this.numberOfAyat }}
                                            </div>
                                        </dd>
                                    </dl>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- end cards -->
        <div class="mx-auto my-8 px-4 sm:px-6 lg:px-0">
            <div class="mt-2 lg:mx-8 grid grid-cols-1 gap-5 md:grid-cols-5 lg:grid-cols-6">
                <div class="bg-white md:col-span-3 lg:col-span-6 shadow rounded-lg">
                    <h2 class="m-8 text-sm font-medium text-gray-500 truncate">
                        عدد الاجزاء
                    </h2>
                    <apexchart type="bar" :options="options" :series="series"></apexchart>
                </div>
                <div class="grid content-around md:col-span-2 lg:col-span-3 bg-white shadow rounded-lg">
                    <apexchart type="donut" :options="chartOptions" :series="seriesDonut"></apexchart>
                </div>
                <div class="grid content-around md:col-span-2 lg:col-span-3 bg-white shadow rounded-lg">
                    <apexchart type="donut" :options="chartOptionsMasrat" :series="masratseriesDonut"></apexchart>
                </div>
            </div>
        </div>
        <!-- App version display -->
        <div class="px-4 sm:px-6 lg:px-8 text-center text-gray-500 text-sm mt-4">
            إصدار الواجهة: {{ appVersion }}
        </div>
    </main>
</template>

<script>
import url from '@/url';
import axios from 'axios';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import * as XLSX from 'xlsx';
import saveAs from 'file-saver';
import appLogo from '@/assets/logo.png';

class masterSessionsDto {
    constructor(data) {
        this.id = data.id || null;
        this.sessionsId = data.sessionsId || null;
        this.sessionsName = data.sessionsName || null;
    }
}
export default {
    components: { VueDatePicker },
    data() {
        return {
            options: {},
            series: [],
            radialseries: [],
            radialOptions: {},
            masterSessionsList: [],
            masterSessionValue: "",
            sessionsId: "",
            organizations: [],
            selectedOrganizationId: "",
            numberOfParts: null,
            numberOfHasnat: null,
            numberOfHroof: null,
            numberOfAyat: null,
            totalOfEnd: null,
            totalPages: null,
            totalPagesReviewed: null,
            totalPagesSaved: null,
            totalStudent: null,
            stageStudentCount: {},
            masratStudentCount: {},
            studentList: [],
            seriesDonut: [],
            masratseriesDonut: [],
            chartOptions: {},
            chartOptionsMasrat: {},
            startDate: "",
            endDate: "",
            date: "",
            format: "",
            studentsList: [],
            url: '', // Initialize the url variable
            appVersion: process.env.VUE_APP_VERSION || 'unknown',
            appLogo: appLogo,
        }
    },
    computed: {
        selectedSessionName() {
            if (this.masterSessionValue === "all") {
                return 'جميع الجلسات';
            }
            const session = this.masterSessionsList.find(s => s.id === this.masterSessionValue);
            return session ? session.sessionsName : 'الاحصائيات اليومية';
        },
        selectedOrganization() {
            return this.organizations.find(org => org.id === this.selectedOrganizationId);
        },
        selectedOrganizationName() {
            return this.selectedOrganization ? this.selectedOrganization.name : 'جميع الجهات';
        }
    },
    mounted() {
        this.startDate = this.formattedDate(new Date());
        this.endDate = this.formattedDate(new Date());
        this.getMasterSessions();
        this.fetchOrganizations();
    }, methods: {
        getMasterSessions() {
            // Get tenant_id from JWT token
            let tenantId = null;
            try {
                const token = localStorage.getItem('token');
                if (token) {
                    const payload = JSON.parse(atob(token.split('.')[1]));
                    tenantId = payload.tenantId || payload.tenant_id || null;
                }
            } catch (e) {
                console.warn('Could not extract tenantId from token:', e);
            }

            // Build URL with tenantId as query parameter
            let urlWithParams = url.master_sessions;
            if (tenantId) {
                urlWithParams += `?tenantId=${encodeURIComponent(tenantId)}`;
            }

            axios.get(process.env.VUE_APP_SERVICE_URL + urlWithParams, {
                headers: {
                    'X-Authorization': localStorage.getItem('token'),
                }
            },)
                .then(response => {
                    this.masterSessionsList = response.data.result.data.map(data => new masterSessionsDto(data));
                    this.masterSessionValue = this.masterSessionsList[0].id;
                    this.sessionsId = this.masterSessionsList[0].sessionsId;
                    this.getDashBordData();
                    this.onClickDate();
                })
                .catch(error => {
                    console.error('Error fetching data', error);
                });
        },
        async fetchOrganizations() {
            try {
                // Get tenant_id from JWT token
                let tenantId = null;
                try {
                    const token = localStorage.getItem('token');
                    if (token) {
                        const payload = JSON.parse(atob(token.split('.')[1]));
                        tenantId = payload.tenantId || payload.tenant_id || null;
                    }
                } catch (e) {
                    console.warn('Could not extract tenantId from token:', e);
                }

                // Build URL with tenantId as query parameter
                let urlWithParams = url.organizations;
                if (tenantId) {
                    urlWithParams += `?tenantId=${encodeURIComponent(tenantId)}`;
                }

                const response = await axios.get(process.env.VUE_APP_SERVICE_URL + urlWithParams, {
                    headers: {
                        'X-Authorization': localStorage.getItem('token'),
                    }
                });
                if (response.data?.result?.data) {
                    this.organizations = response.data.result.data;
                } else if (response.data?.data) {
                    this.organizations = response.data.data;
                }
            } catch (error) {
                console.error('Error fetching organizations:', error);
                // Don't show error for organizations as it's optional
            }
        },
        async getDashBordData() {
            try {
                // Get tenant_id from JWT token
                let tenantId = null;
                try {
                    const token = localStorage.getItem('token');
                    if (token) {
                        const payload = JSON.parse(atob(token.split('.')[1]));
                        tenantId = payload.tenantId || payload.tenant_id || null;
                    }
                } catch (e) {
                    console.warn('Could not extract tenantId from token:', e);
                }

                const requestData = {
                    dateFrom: this.startDate,
                    dateTo: this.endDate
                };
                
                // Add sessionId only if not "all sessions"
                if (this.masterSessionValue !== "all") {
                    requestData.sessionId = this.masterSessionValue;
                }
                
                // Add tenantId if available
                if (tenantId) {
                    requestData.tenantId = tenantId;
                }
                
                console.log("Request data:", requestData);
                
                const response = await axios.post(process.env.VUE_APP_SERVICE_URL + url.dashboard,
                    requestData,
                    {
                        headers: {
                            'X-Authorization': localStorage.getItem('token'),
                        },
                    },
                );
                this.totalOfEnd = response.data.result.data.totalOfEnd;
                this.totalPages = response.data.result.data.totalPages;
                this.totalPagesReviewed = response.data.result.data.totalPagesReviewed;
                this.totalPagesSaved = response.data.result.data.totalPagesSaved;
                this.totalStudent = response.data.result.data.totalStudent;
                this.stageStudentCount = response.data.result.data.stageStudentCount;
                this.masratStudentCount = response.data.result.data.massaratStudentCount;
                this.studentList = response.data.result.data.studentList;
                // Use values from backend if available, otherwise calculate in frontend (backward compatibility)
                this.numberOfHasnat = response.data.result.data.totalHasnat ?? (this.totalPages * 5000);
                this.numberOfHroof = response.data.result.data.totalHroof ?? (this.totalPages * 535);
                this.numberOfAyat = response.data.result.data.totalAyat ?? (this.totalPages * 10);
                this.numberOfParts = (this.totalPages / 20).toFixed(2);

                const studentNamesList = [];
                const studentTotalReviewedList = [];
                this.studentsList = [];
                this.studentList.forEach(student => {
                    studentNamesList.push(student.studentName);
                    studentTotalReviewedList.push(student.totalReviewed)
                    this.studentsList.push(student);
                })

                const stageNamesList = [];
                const stageCountsList = [];
                const msaratNamesList = [];
                const msaratCountsList = [];
                for (const [stageName, stageCount] of Object.entries(this.stageStudentCount)) {
                    stageNamesList.push(stageName); // Push stage name into stageNamesList
                    stageCountsList.push(stageCount); // Push stage count into stageCountsList
                }
                for (const [msaratName, msaratCount] of Object.entries(this.masratStudentCount)) {
                    msaratNamesList.push(msaratName); // Push stage name into stageNamesList
                    msaratCountsList.push(msaratCount); // Push stage count into stageCountsList
                }


                this.updateDashboard(studentNamesList, studentTotalReviewedList)
                this.updateDashboardDonut(stageNamesList, stageCountsList, msaratNamesList, msaratCountsList);
            } catch (error) {
                console.error(error);
            }
        },
        updateDashboard(studentNamesList, studentTotalReviewedList) {
            this.options = {
                chart: {
                    type: 'bar',
                    height: 350,
                },
                xaxis: {
                    categories: studentNamesList,
                },
                plotOptions: {
                    bar: {
                        columnWidth: '40%',
                        borderRadius: 5,
                        dataLabels: {
                            position: 'top',
                        },
                    },
                },
                colors: ['#7A8B7A'], // Using hafadh-olive
            };
            this.series = [
                {
                    name: 'الورد اليومي',
                    data: studentTotalReviewedList,
                },
            ];
            this.radialseries = [60];
            this.radialOptions = {
                chart: {
                    height: 350,
                    type: 'radialBar',
                },
                colors: ['#B8956B'], // Using hafadh-gold
                stroke: {
                    lineCap: 'round',
                },
                plotOptions: {
                    radialBar: {
                        hollow: {
                            size: '70%',
                        },
                        track: {
                            show: true,
                            startAngle: undefined,
                            endAngle: undefined,
                            background: '#F7F6F4', // Using bg-secondary
                            strokeWidth: '97%',
                            opacity: 1,
                            margin: 5,
                            dropShadow: {
                                enabled: false,
                                top: 0,
                                left: 0,
                                blur: 3,
                                opacity: 0.5,
                            },
                        },
                        dataLabels: {
                            show: true,
                            name: {
                                show: true,
                                fontSize: '14px',
                                fontFamily: undefined,
                                fontWeight: 600,
                                color: '#2F332F', // Using text-primary
                                offsetY: -10,
                            },
                        },
                    },
                },
                labels: ['المستوى التعليمي'],
            };
        },
        updateDashboardDonut(stageNamesList, stageCountsList, msaratNamesList, msaratCountsList) {
            const donutColors = {
                series1: '#B8956B',  // hafadh-gold
                series2: '#7A8B7A',  // hafadh-olive
                series3: '#A8C4A8',  // hafadh-mint
                series4: '#C4A373',  // hafadh-tan
            };

            this.seriesDonut = stageCountsList;
            this.masratseriesDonut = msaratCountsList
            this.chartOptions = {
                chart: {
                    type: 'donut',
                },
                stroke: { width: 0 },
                labels: stageNamesList,
                colors: [
                    donutColors.series1,
                    donutColors.series2,
                    donutColors.series3,
                    donutColors.series4,
                ],
                dataLabels: {
                    enabled: true,
                    formatter: (val) => `${parseInt(val, 10)}%`,
                },
                legend: {
                    position: 'bottom',
                    markers: { offsetX: 3 },
                    labels: { colors: '#2F332F' }, // Using text-primary
                    itemMargin: {
                        vertical: 5,
                        horizontal: 10,
                    },
                },
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                name: {
                                    fontSize: '1.5rem',
                                },
                                value: {
                                    fontSize: '1.5rem',
                                    color: '#2F332F', // Using text-primary
                                    formatter: (val) => `${parseInt(val, 10)}`,
                                },
                                total: {
                                    show: true,
                                    fontSize: '1.5rem',
                                    label: 'المسار التعليمي',
                                    // formatter: () => '100%',
                                    color: '#6B7070', // Using text-secondary
                                },
                            },
                        },
                    },
                },
                responsive: [
                    {
                        breakpoint: 992,
                        options: {
                            chart: {
                                height: 380,
                            },
                            legend: {
                                position: 'bottom',
                            },
                        },
                    },
                    {
                        breakpoint: 576,
                        options: {
                            chart: {
                                height: 320,
                            },
                            plotOptions: {
                                pie: {
                                    donut: {
                                        labels: {
                                            show: true,
                                            name: {
                                                fontSize: '1rem',
                                            },
                                            value: {
                                                fontSize: '1rem',
                                            },
                                            total: {
                                                fontSize: '1rem',
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                ],
                title: {
                    text: 'المسار التعليمي',
                    align: 'center',
                    style: {
                        fontSize: '16px',
                        color: '#6B7070', // Using text-secondary
                    },
                },
            };

            this.chartOptionsMasrat = {
                chart: {
                    type: 'donut',
                },
                stroke: { width: 0 },
                labels: msaratNamesList,
                colors: [
                    donutColors.series1,
                    donutColors.series2,
                    donutColors.series3,
                    donutColors.series4,
                ],
                dataLabels: {
                    enabled: true,
                    formatter: (val) => `${parseInt(val, 10)}%`,
                },
                legend: {
                    position: 'bottom',
                    markers: { offsetX: 3 },
                    labels: { colors: '#2F332F' }, // Using text-primary
                    itemMargin: {
                        vertical: 5,
                        horizontal: 10,
                    },
                },
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                name: {
                                    fontSize: '1.5rem',
                                },
                                value: {
                                    fontSize: '1.5rem',
                                    color: '#2F332F', // Using text-primary
                                    formatter: (val) => `${parseInt(val, 10)}`,
                                },
                                total: {
                                    show: true,
                                    fontSize: '1.5rem',
                                    label: 'المسارات',
                                    // formatter: () => '100%',
                                    color: '#6B7070', // Using text-secondary
                                },
                            },
                        },
                    },
                },
                responsive: [
                    {
                        breakpoint: 992,
                        options: {
                            chart: {
                                height: 380,
                            },
                            legend: {
                                position: 'bottom',
                            },
                        },
                    },
                    {
                        breakpoint: 576,
                        options: {
                            chart: {
                                height: 320,
                            },
                            plotOptions: {
                                pie: {
                                    donut: {
                                        labels: {
                                            show: true,
                                            name: {
                                                fontSize: '1rem',
                                            },
                                            value: {
                                                fontSize: '1rem',
                                            },
                                            total: {
                                                fontSize: '1rem',
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                ],
                title: {
                    text: 'المسارت',
                    align: 'center',
                    style: {
                        fontSize: '16px',
                        color: '#6B7070', // Using text-secondary
                    },
                },
            };
        },
        onClickDate() {
            const listDate = [new Date(), new Date()];
            this.date = this.date === "" ? listDate : this.date;
            this.format = (date) => {
                date = date == null || date == "" ? listDate : date;
                this.startDate = this.formattedDate(date[0]);
                this.endDate = this.formattedDate(date[1] === "" || date[1] === null || date[1] === undefined ? new Date() : date[1]);
                return `من ${this.startDate} الى ${this.endDate} `;
            }
        },
        formattedDate(date) {
            if (date != null && date != undefined && date != "") {
                const year = date.getFullYear();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const day = date.getDate().toString().padStart(2, '0');
                return `${year}-${month}-${day}`;
            }
        },
        downloadReport() {
            const headersFromTo = ['من تاريخ', this.formattedDate(this.date[0]), 'الى تاريخ', this.formattedDate(this.date[1] === "" || this.date[1] === null || this.date[1] === undefined ? new Date() : this.date[1])];
            const headers = ['م', 'رقم الدارس', 'الدارس', 'عدد اوجة الورد اليومي'];
            const titleOfStudent = "عدد الدارسين";
            const titleOfPages = "عدد الأوجهة";
            const titleOfParts = "عدد الاجزاء";
            const totalOfEnd = "عدد الختمات";

            const data = this.studentsList.map((student, index) => ({
                "م": index + 1,
                "رقم الدارس": student.studentId,
                "الدارس": student.studentName,
                "عدد اوجة الورد اليومي": student.totalReviewed,
            }));

            // Convert data to worksheet
            const ws = XLSX.utils.json_to_sheet(data, { origin: 2 });


            ws['A1'] = { t: "s", v: headersFromTo[0] + " " + headersFromTo[1] + " " + headersFromTo[2] + " " + headersFromTo[3] };
            ws['!merges'] = [{ s: { r: 1, c: 0 }, e: { r: 0, c: 3 } }];


            ws['E4'] = { t: "s", v: titleOfStudent }
            //todo please put data here 
            ws['E5'] = { t: "s", v: this.totalStudent }

            ws['E6'] = { t: "s", v: titleOfPages }
            //todo please put data here 
            ws['E7'] = { t: "s", v: this.totalPages }

            ws['F4'] = { t: "s", v: titleOfParts }
            //todo please put data here 
            ws['F5'] = { t: "s", v: this.numberOfParts }

            ws['F6'] = { t: "s", v: totalOfEnd }
            //todo please put data here 
            ws['F7'] = { t: "s", v: this.totalOfEnd }


            headers.forEach((header, index) => {
                ws[XLSX.utils.encode_cell({ r: 2, c: index })] = { t: "s", v: header };
            });

            ws['!ref'] = 'A1:H' + data.length + 6;

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

            // Convert workbook to binary Excel file and trigger download
            const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([wbout], { type: 'application/octet-stream' });
            const fileName = ' التقرير من' + this.formattedDate(this.date[0]) + " الى" + this.formattedDate(this.date[1] === "" || this.date[1] === null || this.date[1] === undefined ? new Date() : this.date[1]);
            if (navigator.msSaveBlob) {
                // For IE 10+
                navigator.msSaveBlob(blob, fileName);
            } else {
                // For modern browsers
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
            }
        },
        async downloadReportFromBe(type, displayName) {
            try {
                await axios.get(process.env.VUE_APP_SERVICE_URL + url.reports + this.sessionsId,
                    {
                        params: {
                            type: type,
                            startDate: this.startDate,
                            endDate: this.endDate,
                            displayName: displayName,
                        },
                        headers: {
                            'X-Authorization': localStorage.getItem('token'),
                        },
                        responseType: 'blob',
                    },
                ).then(date => {
                    console.log(date.Blob);
                    const blob = new Blob([date.data], { type: date.headers['content-type'] });
                    saveAs(blob, "reports.pdf");

                });
            } catch (error) {
                console.error(error);
            }
        },
        changeSessionsId(masterSessionValue) {
            if (masterSessionValue === "all") {
                console.log("Selected all sessions");
                this.sessionsId = null; // أو قيمة تدل على جميع الجلسات
            } else {
                this.sessionsId = this.masterSessionsList[masterSessionValue - 1].sessionsId;
            }
            this.getDashBordData();
        },
        async sessionsReport() {
            try {
                await axios.get(process.env.VUE_APP_SERVICE_URL + url.sessions_report + this.masterSessionValue,
                    {
                        headers: {
                            'X-Authorization': localStorage.getItem('token'),
                        },
                        responseType: 'blob',
                    },
                ).then(date => {
                    console.log(date.Blob);
                    const blob = new Blob([date.data], { type: date.headers['content-type'] });
                    saveAs(blob, "reports.xlsx");
                });
            } catch (error) {
                if (error.response.status === 400) {
                    alert("لا يوجد للحلقة اي مواعيد لهذا اليوم");
                } else {
                    alert('حدث خطأ ما الرجاء المحاولة مرة اخرى');
                }
            }
        },
    }
};
</script>
<style scoped>
.button {
    @apply px-4 py-2 bg-customHafadhColor text-white rounded hover:bg-customHafadhColor w-20 h-10;
}

.button-download {
    @apply px-3 py-1.5 bg-customHafadhColor text-white rounded hover:bg-customHafadhColor w-48 h-9 text-sm;
}

/* PDF Export Styles */
.pdf-export {
    direction: rtl;
    padding: 15px;
    background: white;
    font-size: 12px;
}

/* Hide interactive elements in PDF */
.pdf-export .mt-2.flex.flex-wrap.items-center.gap-3 {
    display: none !important;
}

.pdf-export button,
.pdf-export select,
.pdf-export input,
.pdf-export .VueDatePicker {
    display: none !important;
}

/* Report Header Styles (always visible) */
.report-header {
    direction: rtl;
    margin-bottom: 24px;
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    border: 2px solid #7A8B7A;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(122, 139, 122, 0.15);
    padding: 24px;
}

.header-logos {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    min-height: 60px;
}

.left-logo, .right-logo {
    flex: 0 0 100px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.center-title {
    flex: 1;
    text-align: center;
    padding: 0 15px;
}

.organization-logo, .app-logo {
    max-width: 80px;
    max-height: 80px;
    object-fit: contain;
    border-radius: 8px;
}

.pdf-export .organization-logo, .pdf-export .app-logo {
    max-width: 60px;
    max-height: 60px;
}

.pdf-title {
    font-size: 20px;
    font-weight: bold;
    color: #c9a06c;
    margin: 0 0 6px 0;
    font-family: 'Tajawal', sans-serif;
}

.pdf-export .pdf-title {
    font-size: 26px !important;
    margin: 0 0 4px 0 !important;
    font-family: 'Arial Unicode MS', 'Tahoma', 'Arial', sans-serif !important;
    direction: rtl !important;
    unicode-bidi: bidi-override !important;
}

.pdf-subtitle {
    font-size: 14px;
    color: #666;
    margin: 0 0 3px 0;
    font-family: 'Tajawal', sans-serif;
}

.pdf-export .pdf-subtitle {
    font-size: 17px !important;
    margin: 0 !important;
    font-family: 'Arial Unicode MS', 'Tahoma', 'Arial', sans-serif !important;
    direction: rtl !important;
    unicode-bidi: bidi-override !important;
}

.pdf-organization {
    font-size: 12px;
    color: #888;
    margin: 0;
    font-family: 'Tajawal', sans-serif;
}

.header-divider {
    border: none;
    border-top: 1.5px solid #c9a06c;
    margin: 8px 0;
}

.pdf-export .header-divider {
    margin: 6px 0 !important;
}

/* Cards and Charts styling for PDF */
.pdf-export .grid {
    gap: 8px !important;
}

.pdf-export .bg-hafadh-olive,
.pdf-export .bg-hafadh-gold {
    print-color-adjust: exact !important;
    -webkit-print-color-adjust: exact !important;
}

.pdf-export .text-white {
    color: white !important;
}

/* Print styles for browser printing */
@media print {
    /* Hide interactive elements when printing */
    .mt-2.flex.flex-wrap.items-center.gap-3 {
        display: none !important;
    }
    
    button, select, input, .VueDatePicker {
        display: none !important;
    }
    
    /* Optimize layout for printing */
    .dashboard-report {
        margin: 0 !important;
        padding: 10px !important;
        box-shadow: none !important;
    }
    
    .report-header {
        margin-bottom: 15px !important;
        padding: 15px !important;
        border: 2px solid #7A8B7A !important;
        border-radius: 8px !important;
        background: white !important;
        box-shadow: none !important;
    }
    
    .grid {
        gap: 8px !important;
    }
    
    .bg-hafadh-olive,
    .bg-hafadh-gold {
        print-color-adjust: exact !important;
        -webkit-print-color-adjust: exact !important;
    }
    
    .text-white {
        color: white !important;
    }
    
    /* Ensure page breaks work properly */
    .grid > div {
        page-break-inside: avoid !important;
        break-inside: avoid !important;
    }
}
</style>